module.exports = __webpack_public_path__ + "img/cabbage-clean-small.ebd07ec1.png";